<template>
    <ftsTable v-bind:dataTables="dataToTable" :cols="colsTables"></ftsTable>
</template>

<script>
import ftsTable from './ftsTable';
import Axios from 'axios';
import globalStore from './../../variables'


export default {
    name: 'ftsGetDataTable',
    data() {
        return {
            page: 1,
            size: 20,
            sort: 1,
            desc: true,
            dataToTable: []
        }
    },
    components: {
        ftsTable: ftsTable
    },
    props: {
        linkToData: String,
        colsTables: Array
    },
    methods: {
        getSimList() {
            Axios.get(globalStore.data.restApiUrl + this.linkToData + '?page=' + this.page + '&size=' + this.size + '&sort=' + this.sort + '&desc=' + this.desc)
                .then(response => {
                    if (response.status == 200) {
                        this.dataToTable = response.data.response
                    } else {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Getting data error',
                            text: 'Something was wrong in getting data from database. Please contact with support.',
                            duration: 5000,
                        });

                        return false;
                    }
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Something was wrong in getting data from database. Please contact with support.',
                        duration: 5000,
                    });

                    return false;
                })
        }
    },
    mounted() {
        this.getSimList();
    }
}
</script>

<style lang="scss">

</style>